import axiosInstance from "../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const paymentVoucherURL = `api/v1/account-app/vouchermain`;

//obtaining the paginated data
export const getPaymentVoucher = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${paymentVoucherURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}&voucherType=11`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPaymentVoucher = () => axiosInstance.get(`${paymentVoucherURL}/list?ordering=-id&voucherType=11`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePaymentVoucher = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${paymentVoucherURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}&voucherType=11`
  );

// get by id
export const getPaymentVoucherById = (id) => axiosInstance.get(`${paymentVoucherURL}/retrieve/${id}`);

//creating function
export const createPaymentVoucher = (body) => axiosInstance.post(`${paymentVoucherURL}/create`, body);
//creating function
export const createCostCenterDetails = (body) =>
  axiosInstance.post(`api/v1/cost-center/cost-center-details/create`, body);
//updating function
export const updatePaymentVoucher = (id, body) => axiosInstance.patch(`${paymentVoucherURL}/update/${id}`, body);
// approve function
export const approvePaymentVoucher = (id, body) => axiosInstance.patch(`${paymentVoucherURL}/approve/${id}`, body);
//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${paymentVoucherURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
